import {Box, InputLabel, Switch, TextField} from '@mui/material'
import * as React from 'react'
import {LargeYSpace, SmallXSpace} from './space'

export type PartnerInfoType = {
  appId: string
  walletId: string
  authorization: string
  redirectTo: string
  message: string
  signature: string
  isSandbox: boolean
  isTestnet: boolean
}

const defaultPartentInfo: PartnerInfoType = {
  appId: '',
  walletId: '',
  authorization: '',
  redirectTo: '',
  message: '',
  signature: '',
  isSandbox: false,
  isTestnet: false,
}

export const usePartnerInfo = () => {
  const [appId, setAppId] = React.useState(defaultPartentInfo.appId)
  const [walletId, setWalletId] = React.useState(defaultPartentInfo.walletId)
  const [authorization, setAuthorization] = React.useState(
    defaultPartentInfo.authorization,
  )
  const [redirectTo, setRedirectTo] = React.useState(
    defaultPartentInfo.redirectTo,
  )
  const [message, setMessage] = React.useState(defaultPartentInfo.message)
  const [signature, setSignature] = React.useState(defaultPartentInfo.signature)
  const [isSandbox, setIsSandbox] = React.useState(defaultPartentInfo.isSandbox)
  const [isTestnet, setIsTestnet] = React.useState(defaultPartentInfo.isTestnet)

  return {
    appId,
    setAppId,
    walletId,
    setWalletId,
    authorization,
    setAuthorization,
    redirectTo,
    setRedirectTo,
    message,
    setMessage,
    signature,
    setSignature,
    isSandbox,
    setIsSandbox,
    isTestnet,
    setIsTestnet,
  }
}

export const filterPartnerInfo = (partnerInfo: PartnerInfoType) => {
  const keys = Object.keys(defaultPartentInfo) as Array<keyof PartnerInfoType>

  return keys.reduce((acc: PartnerInfoType, curr: keyof PartnerInfoType) => {
    if (partnerInfo[curr] !== defaultPartentInfo[curr]) {
      return {
        ...acc,
        [curr]: partnerInfo[curr],
      }
    }

    return acc
  }, {} as PartnerInfoType)
}

export const PartnerInfo = ({
  appId,
  setAppId,
  walletId,
  setWalletId,
  authorization,
  setAuthorization,
  redirectTo,
  setRedirectTo,
  message,
  setMessage,
  signature,
  setSignature,
  isSandbox,
  setIsSandbox,
  isTestnet,
  setIsTestnet,
}: ReturnType<typeof usePartnerInfo>) => {
  return (
    <>
      <Box sx={{display: 'flex'}}>
        <TextField
          onChange={(event) => setAppId(event.target.value)}
          sx={{width: '200px'}}
          id="app-id"
          label="App ID (optional)"
          variant="outlined"
          value={appId}
        />

        <SmallXSpace />

        <TextField
          onChange={(event) => setWalletId(event.target.value)}
          sx={{width: '200px'}}
          id="wallet-id"
          label="Wallet ID (optional)"
          variant="outlined"
          value={walletId}
        />
      </Box>

      <LargeYSpace />

      <Box sx={{display: 'flex'}}>
        <TextField
          onChange={(event) => setAuthorization(event.target.value)}
          sx={{width: '200px'}}
          id="authorization"
          label="Authorization (optional)"
          variant="outlined"
          value={authorization}
        />

        <SmallXSpace />

        <TextField
          onChange={(event) => setRedirectTo(event.target.value)}
          sx={{width: '200px'}}
          id="redirect-to"
          label="Redirect To (optional)"
          variant="outlined"
          value={redirectTo}
        />
      </Box>

      <LargeYSpace />

      <Box sx={{display: 'flex'}}>
        <TextField
          onChange={(event) => setMessage(event.target.value)}
          sx={{width: '200px'}}
          id="message"
          label="Message (optional)"
          variant="outlined"
          value={message}
        />

        <SmallXSpace />

        <TextField
          onChange={(event) => setSignature(event.target.value)}
          sx={{width: '200px'}}
          id="signature"
          label="Signature (optional)"
          variant="outlined"
          value={signature}
        />
      </Box>

      <LargeYSpace />

      <InputLabel id="testnet">Testnet</InputLabel>

      <Switch
        id="testnet"
        onChange={(event) => setIsTestnet(event.target.checked)}
        value={isTestnet}
      />

      <LargeYSpace />

      <InputLabel id="sandbox">Sandbox</InputLabel>

      <Switch
        id="sandbox"
        onChange={(event) => setIsSandbox(event.target.checked)}
        value={isSandbox}
      />
    </>
  )
}
